import { setTerminal } from '@/Infrastructure/applicationSlice';
import { triniumApi } from '../slice';
import { MyProfile, Terminal } from '../types';

export type MutableTerminalPreferences = Partial<Pick<Terminal, 'disableDeletePaymentsWarning' | 'finalChargesBccEmailAddr'>>;

function transformMyProfile(response: MyProfile): MyProfile {
  return {
    ...response,
    terminals: response.terminals
      .filter((terminal) => terminal.isActive)
      .map((terminal) => ({
        ...terminal,
        incCustInfo: terminal.incCustInfo ? terminal.incCustInfo : false, // if incCustInfo is null or undefined, return false
        isMc3Terminal: terminal.isMc3Terminal ? terminal.isMc3Terminal : false,
        promptForCntrChassisDup: terminal.promptForCntrChassisDup ? terminal.promptForCntrChassisDup : false,
        transportMode: terminal.transportMode ?? ''
      }))
  };
}

export const myProfileSlice = triniumApi.injectEndpoints({
  endpoints(builder) {
    return {
      fetchMyProfile: builder.query<MyProfile, undefined>({
        query: () => '/myprofile',
        transformResponse: transformMyProfile
      }),

      updateMyProfile: builder.mutation<MyProfile, { terminalNumber: string; changes: MutableTerminalPreferences }>({
        query: ({ terminalNumber, changes }) => ({
          url: `${terminalNumber}/myprofile`,
          method: 'PATCH',
          body: changes
        }),
        transformResponse: transformMyProfile,
        async onQueryStarted({ terminalNumber }, { dispatch, queryFulfilled }) {
          try {
            const { data: profile } = await queryFulfilled;

            await dispatch(myProfileSlice.util.upsertQueryData('fetchMyProfile', undefined, profile));

            // selectedTerminal is a snapshot taken by TerminalProxy, which only re-selects when the terminal number changes
            const updatedTerminal = profile.terminals.find((terminal) => terminal.number === terminalNumber);
            if (updatedTerminal) {
              dispatch(setTerminal(updatedTerminal));
            }
          } catch {
            // Nothing was written to the cache, so a failed update has nothing to roll back
          }
        }
      })
    };
  }
});

export const { useFetchMyProfileQuery, useUpdateMyProfileMutation } = myProfileSlice;
